<template>
  <div :class='classes' class='focus:outline-none'>
    <slot name='default' />
  </div>
</template>
<script>
import Hammer from 'hammerjs';
export default {
  props:{
    value:{
      type:Number,
      required:true
    },
    enableTap:{
      type: Boolean,
      default: false
    },
    boundsChecker: {
      type:Function,
      default:() => {
        return {valid:true}
      }
    }
  },
  data() {
    return {
      isDragging: false
    }
  },
  methods: {
    onPanStart(e) {
      this.startValue = this.value;
      this.$emit('panstart');
      this.isDragging = true;
    },
    onPanMove({deltaX,deltaY}) {
      const newValue = this.startValue + deltaX;
      const {valid,v} = this.boundsChecker(newValue);
      if (valid) {
        this.$emit('input', newValue);
      } else {
        this.$emit('input', v);
      }
    },
    onPanEnd(e) {
      this.$emit('panend');
      this.isDragging = false;
    },
    onTap() {
      if (this.enableTap) {
        console.log('you tapped it');
        this.$emit("tap");
      }
    },
    onPressStart() {
      this.$emit('press');
    },
    onPressEnd() {
      this.$emit('pressup');
    }
  },
  beforeDestroy() {
    this.hammer.off('panstart');
    this.hammer.off('panmove');
    this.hammer.off('panend');
    this.hammer.off('tap');
  },
  mounted() {
    const panOpts = {
      threshold:15,
      pointers:1
    }
    this.hammer = new Hammer.Manager(this.$el, {
    })
    const pan = new Hammer.Pan(panOpts);

    this.hammer.add(pan);

    this.hammer.on('panstart', this.onPanStart);
    this.hammer.on('panmove', this.onPanMove);
    this.hammer.on('panend', this.onPanEnd);

    //if (this.enableTap) {
      this.hammer.add(new Hammer.Tap());
      this.hammer.on('tap', this.onTap);
    //}

  },
  computed:{
    classes() {
      if (this.isDragging) {
        return 'bg-red-300';
      } else {
        return '';
      }
    }
  }
}
</script>
